module.exports = __webpack_public_path__ + "87af0ab1c39e9f4996e109c83f6ab8df.fbx";